
import Modal from "@/components/Modal.vue";
import {Menu as MenuApi} from "@/services/SOLO";
import {translations} from '@/mixins';
import { Option, Select } from 'element-ui';
import {
  ValidationProvider,
} from "vee-validate";
import {Component, ProvideReactive, Prop, Vue, Watch, Emit,} from "vue-property-decorator";
import { Category as CategoryApi } from "@/services/SOLO";

@Component({
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ValidationProvider,
  },
  mixins: [translations],
})
export default class NewPageModal extends Vue {
  durationType: string = '';
  durations: any = [];
  numOfHours: any = null;
  $notify: any;

  @Prop() itemId!: any
  @Prop() open!: Boolean
  
  get isOpen(): Boolean {
    return this.open;
  }

  set isOpen(newVal: Boolean) {
    this.$emit("enableDisableModal", newVal);
  }

  mounted() {
    this.durations = [
      {
        value: "1",
        text: "1 Hour"
      },
      {
        value: "4",
        text: "4 Hours"
      },
      {
        value: "__next_business_day__",
        text: "Next Business Date"
      },
      {
        value: "custom",
        text: "Custom"
      }
    ];
  }

  close() {
    this.$emit("closeModal", false);
  }

  confirmDuration() {
    let hours = '';

    if (this.durationType != 'custom') {
      hours = this.durationType;
    } else {
      hours = this.numOfHours;
    }

    let payload = {
      'schedule-disabled-hours': hours,
    };

    MenuApi.updateModifierItem(payload, this.$route.params.modifierId, this.itemId)
      .then((response) => {
        this.$notify({
          title: "DURATION SET!",
          verticalAlign: "bottom",
          horizontalAlign: "left",
          message: "Duration has been set successfully",
          type: "success",
          icon: "fas fa-check",
        });
        this.durationType = "";
        this.numOfHours = null;
        this.$emit("enableDisableModal", false, this.itemId);
      })
      .catch((err) => {
        this.$notify({
          title: "SYSTEM ERROR!",
          verticalAlign: "bottom",
          horizontalAlign: "left",
          message: "Something went wrong, please try again!",
          type: "danger",
          icon: "fas fa-bomb",
        });
      });
  }
}
